<template>
  <global-tag>
    <el-form
      class="queryForm"
      ref="queryForm"
      :model="queryForm"
      label-width="120px"
    >
    <el-row >
        <el-col :span="8">
          <el-form-item label="姓名：">
            <el-input placeholder="请输入姓名" clearable v-model="queryForm.customerName"></el-input>
          </el-form-item>
         </el-col>
         <el-col :span="8">
          <el-form-item label="手机号：">
            <el-input placeholder="请输入手机号"  clearable v-model="queryForm.phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="22">
          <el-form-item label="地址：">
            <el-select
              v-model="queryForm.provinceId"
              placeholder="请选择省"
              @change="handleProvince"
              ref="selectShengChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.cityId"
              placeholder="请选择市"
              @change="handleCity"
              ref="selectShiChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.areaId"
              placeholder="请选择区"
              @change="handleArea"
              ref="selectQuChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.addName"
                :value="item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.streetId"
              placeholder="请选择街道"
              @change="streetChange"
              ref="selectJiedaoChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in streetList"
                :key="index"
                :label="item.addName"
                :value="item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.communityId"
              placeholder="请选择社区"
              ref="selectShequChange"
              @change="handleCommunityChange"
              class="address"
            >
              <el-option
                v-for="item in communityList"
                :key="item.addCode"
                :label="item.addName"
                :value="+item.addCode"
              >
              </el-option>
            </el-select>
            <el-input
              clearable
              v-model="queryForm.address"
              style="width: 170px"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button
            size="medium"
            class="searchBtns"
            type="primary"
            @click="QuerySearch"
            >查询
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </global-tag>
</template>
<script>
import request from "@/utils/request"
import globalTag from "@/component/globalTag"

export default {
  name: "queryForm",
  components: { globalTag },
  props: {
    queryForm: {
      type: Object,
    },
  },
  data() {
    return {
      serviceStationList: [],
      serviceStaffList: [],
      userType: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      communityList: [],
    }
  },
  created() {
    this.getTableData()
    this.getServiceStationList()
    //  this.getServiceStaffList()
    this.getusertypeList()
    this.getProvince()
  },
  methods: {
    //获取用户类型
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "usertype",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.userType = res.rows
            }
          }
        })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      // console.log(this.provinceList)
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.queryForm.cityId = ""
      this.queryForm.areaId = ""
      this.queryForm.streetId = ""
      this.queryForm.communityId = ""
      let city = await this.getDistricts(val)
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.queryForm.areaId = ""
      this.queryForm.streetId = ""
      this.queryForm.communityId = ""
      let area = await this.getStreetList(val)
      this.areaList = area
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.queryForm.streetId = ""
      this.queryForm.communityId = ""
      let street = await this.getStreetList(val)
      this.streetList = street
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      this.streetList.forEach((item) => {
        if (item.addName == val) {
          this.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: item.addCode,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  return
                } else {
                  this.communityList = res.content
                }
              }
            })
        }
      })
    },
    //街道地址发生变化
    async streetChange(val) {
      this.queryForm.communityId = ""
      this.queryForm.address = ""
      this.communityList = await this.getStreetList(val)
    },
    // 社区
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },
    Count() {
      if (this.queryForm.endCount < this.queryForm.startCount) {
        this.queryForm.endCount = ""
        this.$message("后者输入的次数应大于前者")
      }
    },
    QuerySearch() {
      let aa = this.queryForm.endCount - this.queryForm.startCount
      if (aa < 2) {
        this.queryForm.startCount = ""
        this.queryForm.endCount = ""
        this.$message("两次输入的次数不能连续")
      }
      this.$emit("QuerySearch")
    },

    // 获取项目列表数据
    getTableData() {
      this.$http
        .request({
          url: "/jjyl/admin/product/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 999,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.product = []
              this.pageConfig.total = 0
            } else {
              this.product = res.content.list || []
            }
          }
        })
    },
    // 机构
    getServiceStationList() {
      let params = {
        pageNo: 1,
        pageSize: 999,
      }
      request({
        url: "/jjyl/admin/serviceStation/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.serviceStationList = res.content.list || []
          } else {
            this.serviceStationList = []
          }
        }
      })
    },
    // 人员
    // 获取表格数据
    getServiceStaffList() {
      let params = {
        pageNo: 1,
        pageSize: 999,
        serviceStationName: this.queryForm.servestationName,
        // ...this.query,
      }
      this.$http
        .request({
          url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.serviceStaffList = []
              return
            }
            this.serviceStaffList = res.content.list
          }
        })
    },
  },
}
</script>
<style lang="less" scoped>
.QuerySearchBtn {
  margin-left: 60px;
}
.address {
  width: 170px !important;
  margin-right: 3px;
}
</style>
